import { Component, Input, OnInit } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { ViewCell } from 'ng2-smart-table';
import { ImgPopupComponent } from '../../dialog/img-popup/img-popup.component';

@Component({
  selector: 'photoB64-event',
  templateUrl: './photoB64-event.component.html',
  styleUrls: ['./photoB64-event.component.css']
})
export class PhotoB64EventComponent implements ViewCell, OnInit {
  public photoB64Event: string;
  public  photoB64License: string;
  @Input() value: string | number;
  @Input() rowData: any;

  constructor(
    private dialogService: NbDialogService,
  ) { }

  ngOnInit() {
    this.photoB64Event = this.rowData.photoB64Event;
    this.photoB64License = this.rowData.photoB64License;
  }

  clicked() {
    this.dialogService.open(ImgPopupComponent, {
      closeOnBackdropClick: true,
      context: {
        photoB64: this.photoB64Event,
        photoB64License: this.photoB64License,
      }
    })
    .onClose.subscribe((resp) => {
      console.log(resp);
    })
  }

}
